import React from 'react';
import PropTypes from 'prop-types';
import { PinterestShareButton } from 'react-share';

import SocialShareAtag from '../Shared/SocialShareAtag';
import Container from '../Shared/Container';
import ButtonContainer from '../Shared/ButtonContainer';
import Icon from '../Shared/Icon';
import IconText from '../Shared/IconText';

const PinterestSocialShareButton = (props) => (
  <Container>
    <PinterestShareButton url={props.url} media={props.pinterestMedia} style={{ outline: 'none' }}>
      <SocialShareAtag backgroundColor="#e50122">
        <ButtonContainer>
          <Icon>
            <svg
              viewBox="0 0 33 33"
              width="16"
              height="16"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <g>
                <path d="M16 0c-8.825 0-16 7.175-16 16s7.175 16 16 16 16-7.175 16-16-7.175-16-16-16zM16 29.863c-1.431 0-2.806-0.219-4.106-0.619 0.563-0.919 1.412-2.431 1.725-3.631 0.169-0.65 0.863-3.294 0.863-3.294 0.45 0.863 1.775 1.594 3.175 1.594 4.181 0 7.194-3.844 7.194-8.625 0-4.581-3.738-8.006-8.544-8.006-5.981 0-9.156 4.019-9.156 8.387 0 2.031 1.081 4.563 2.813 5.369 0.262 0.125 0.4 0.069 0.463-0.188 0.044-0.194 0.281-1.131 0.387-1.575 0.031-0.137 0.019-0.262-0.094-0.4-0.575-0.694-1.031-1.975-1.031-3.162 0-3.056 2.313-6.019 6.256-6.019 3.406 0 5.788 2.319 5.788 5.637 0 3.75-1.894 6.35-4.356 6.35-1.363 0-2.381-1.125-2.050-2.506 0.394-1.65 1.15-3.425 1.15-4.613 0-1.063-0.569-1.95-1.756-1.95-1.394 0-2.506 1.438-2.506 3.369 0 1.225 0.412 2.056 0.412 2.056s-1.375 5.806-1.625 6.887c-0.281 1.2-0.169 2.881-0.050 3.975-5.156-2.012-8.813-7.025-8.813-12.9 0-7.656 6.206-13.863 13.862-13.863s13.863 6.206 13.863 13.863c0 7.656-6.206 13.863-13.863 13.863z" />
              </g>
            </svg>
          </Icon>
          <IconText>Save</IconText>
        </ButtonContainer>
      </SocialShareAtag>
    </PinterestShareButton>
  </Container>
);

PinterestSocialShareButton.propTypes = {
  url: PropTypes.string.isRequired,
  pinterestMedia: PropTypes.string.isRequired,
};

export default PinterestSocialShareButton;
